import { AD_BASE_POSTCARD_TEMPLATES_PATH } from '../constants';
import { authedAxios } from '../shared/axiosWrapper';

export default {
  fetchTemplates(archive) {
    const params = {
      archived: false,
      is_system: false,
      limit: 1000,
    };
    // FIXME: confirm we need this.
    if (archive != undefined) {
      params['archived'] = archive;
    }

    return authedAxios.get(AD_BASE_POSTCARD_TEMPLATES_PATH, { params: params });
  },
  fetchTemplate(id) {
    return authedAxios.get(AD_BASE_POSTCARD_TEMPLATES_PATH + id);
  },
  saveTemplate(id, deliverable) {
    if (id === null || id === undefined || id === 0) {
      return authedAxios.post(AD_BASE_POSTCARD_TEMPLATES_PATH, deliverable);
    } else {
      return authedAxios.put(
        AD_BASE_POSTCARD_TEMPLATES_PATH + id + '/',
        deliverable
      );
    }
  },
  duplicateTemplate(id, name) {
    return authedAxios.put(
      AD_BASE_POSTCARD_TEMPLATES_PATH + id + '/duplicate',
      {
        name: name,
      }
    );
  },
  systemTemplate(id) {
    return authedAxios.post(AD_BASE_POSTCARD_TEMPLATES_PATH + id + '/system', {
      archive: true,
    });
  },
  archiveTemplate(id) {
    return authedAxios.put(AD_BASE_POSTCARD_TEMPLATES_PATH + id + '/archive', {
      archive: true,
    });
  },

  unArchiveTemplate(id) {
    return authedAxios.put(AD_BASE_POSTCARD_TEMPLATES_PATH + id + '/archive', {
      archive: false,
    });
  },

  changeFolder(id, folderId) {
    return authedAxios.put(AD_BASE_POSTCARD_TEMPLATES_PATH + id + '/folder', {
      folder_id: folderId,
    });
  },
  patchTemplate(templateId, payload) {
    return authedAxios.patch(
      AD_BASE_POSTCARD_TEMPLATES_PATH + templateId,
      payload
    );
  },
};
